export enum Locale {
  Nl = "nl-NL",
  En = "en-GB",
}

export enum AppointmentType {
  FaceToFace = "faceToFace",
  Phone = "phone",
  Video = "video",
}

export enum PersonGender {
  Male = "male",
  Female = "female",
  Unknown = "unknown",
}

/** The gender a stored string names, or `null` when it names none. */
export const parsePersonGender = (raw: string | null | undefined): PersonGender | null => {
  if (!raw) {
    return null
  }

  return (Object.values(PersonGender) as string[]).includes(raw) ? (raw as PersonGender) : null
}

/**
 * Entities that are related to patient data in our application.
 *
 * NOTE: In the frontend this is closely related to the `EntityPage.tsx`. At
 * some point we want to include the `Patient` and `Person` entities in
 * here as well.
 */
export enum EntityType {
  Appointment = "appointment",
  Econsult = "econsult",
  MedicationRequest = "medicationRequest",
  RegistrationRequest = "registrationRequest",
}

export enum Day {
  Monday = "monday",
  Tuesday = "tuesday",
  Wednesday = "wednesday",
  Thursday = "thursday",
  Friday = "friday",
  Saturday = "saturday",
  Sunday = "sunday",
}

/** Number of days in a week, derived from {@link Day}. */
export const WEEKDAY_COUNT = Object.keys(Day).length

export enum TimeOfDay {
  Morning = "morning",
  Afternoon = "afternoon",
  Evening = "evening",
  Night = "night",
}

export enum TimeUnit {
  Hour = "hour",
  Day = "day",
  Week = "week",
  Month = "month",
  Year = "year",
}

export enum SortDirection {
  ASC = "ASC",
  DESC = "DESC",
}

export enum CareGroupCommunicationTemplateKey {
  PrivacyStatement = "privacy-statement",
}

export enum AutoMedicStatus {
  Created = "created",
  Success = "success",
  Failed = "failed",
}

export enum AutoMedicWebhookStatus {
  Success = "SUCCESS",
  Failed = "FAILED",
}
